import { ArrowDown } from "lucide-react";

export default function ConversionWaterfall({ stats }) {
  if (!stats) return null;
  const max = Math.max(stats.total_leads, 1);
  const steps = [
    { label: "Leads In", value: stats.total_leads, color: "linear-gradient(90deg,#3B82F6,#60A5FA)" },
    { label: "Calls Scheduled", value: stats.calls_scheduled, color: "linear-gradient(90deg,#6366F1,#818CF8)" },
    { label: "Calls Completed", value: stats.calls_completed, color: "linear-gradient(90deg,#8B5CF6,#A78BFA)" },
    { label: "Closed Won", value: stats.closed_won, color: "linear-gradient(90deg,#10B981,#34D399)" },
  ];
  const conv = (a, b) => (b ? Math.round((a / b) * 1000) / 10 : 0);
  const overall = conv(stats.closed_won, stats.total_leads);

  return (
    <div className="gos-card p-6 fade-up">
      <p className="eyebrow mb-1">Conversion Waterfall</p>
      <h2 className="font-display text-xl font-semibold text-white mb-6">Lead → Close Funnel</h2>

      <div className="space-y-1">
        {steps.map((s, i) => (
          <div key={s.label}>
            <div className="flex items-center gap-4">
              <div className="w-32 shrink-0 text-sm text-slate-300 font-medium">{s.label}</div>
              <div className="flex-1 h-9 rounded-lg bg-white/5 overflow-hidden relative">
                <div
                  className="h-full rounded-lg transition-all duration-700"
                  style={{ width: `${Math.max((s.value / max) * 100, 4)}%`, background: s.color }}
                />
              </div>
              <div className="w-10 text-right font-mono-g text-white font-semibold">{s.value}</div>
            </div>
            {i < steps.length - 1 && (
              <div className="flex items-center gap-1.5 pl-32 ml-4 my-1 text-[11px] text-slate-500">
                <ArrowDown className="w-3 h-3" />
                <span className="font-mono-g text-slate-400">{conv(steps[i + 1].value, s.value)}%</span>
                <span>conversion</span>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-5 pt-4 border-t border-white/8 flex items-center justify-between">
        <span className="eyebrow">Overall Lead → Close</span>
        <span className="font-mono-g text-emerald-400 font-bold">{overall}%</span>
      </div>
    </div>
  );
}
